import React from 'react';
import mapper from './mapper';
import { useDeps } from 'components-di';

const ErrorView = props => {
  const { header, message, subMessage } = props;
  return (
    <div className='width-constrainer fit-viewport-height py3 px2 clearfix flex justify-center flex-column'>
      <div className='mb4'>
        <div className='h2 bold color-attention'>{header}</div>
        <div className='h1'>{message}</div>
        <div className='color-secondary'>{subMessage}</div>
      </div>
    </div>
  );
};

export default useDeps(mapper)(ErrorView);



// WEBPACK FOOTER //
// ./src/ui/views/Error/index.js